import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';

import { QuoteSelectSuppliersDataResponse } from '@/main/models/response';
import { formatCurrency } from '@/main/services/utilsNumber';
import { Cart, CartPart } from '@/main/store/cart';

export function showMessageWhenPaymentPending() {
  toast.error(
    'Payment is pending, please complete the payment to place the order'
  );
}

interface IFormatAddCartProps {
  guidPart: string;
  guidQuote: string;
  externalPartId: string;
  partItem: QuoteSelectSuppliersDataResponse;
}
export function formatAddCart(request: IFormatAddCartProps) {
  const idUnique = uuidv4();
  const { guidPart, guidQuote, externalPartId, partItem } = request;

  const formattedPart: CartPart = {
    id: idUnique,
    guid: partItem.guidQuoteSupplierItem,
    guidPart: guidPart,
    idPartType: partItem.idPartType || 0,
    quantity: 1,
    guidSupplierInventoryWarehouse: partItem.supplierInventory_WarehouseGuid
      ? partItem.supplierInventory_WarehouseGuid
      : '',
    guidQuoteSupplierItem: partItem.guidQuoteSupplierItem
      ? partItem.guidQuoteSupplierItem
      : '',
    deliveryBySupplier: partItem.deliveryBySupplier,
    externalPartId: externalPartId,
    guidSupplierInventory: partItem.supplierInventoryGuid,
    currency: 'USD',
    deliveryDeadline: partItem.deliveryDays || 0,
    partBrand: partItem.partBrandDescription || '',
    partType: partItem.partType || '',
    price: partItem.price || 0,
    priceCap: partItem.priceCap || 0,
    priceCapFormatted: formatCurrency(partItem.priceCap),
    priceDiffPercent: partItem.priceDiffPercent || 0,
    priceFormatted: partItem.priceFormatted || '',
    priceTotalFormatted: partItem.priceFormatted || '',
    shippingCost: partItem.shippingCost || 0,
    totalPrice: partItem.price || 0,
    image: partItem.image || '',
    guidQuoteItem: partItem.quoteItemGuid
  };

  const formattedSupplierCart: Cart = {
    id: idUnique,
    shipingCompany: {
      quotationShipingCompanyItems: []
    },
    isFavoriteSupplier: partItem.isFavoriteSupplier,
    deliveryBySupplier: partItem.deliveryBySupplier,
    deliveryDaysSupplier: partItem.deliveryDays,
    shipingIntegrationIsUnavailable: Boolean(
      partItem.shipingIntegrationIsUnavailable
    ),
    guidSupplierInventory: partItem.supplierInventoryGuid,
    guid: partItem.supplierGuid,
    guidQuote: guidQuote,
    name: partItem.supplier,
    parts: [formattedPart],
    totalPartsPrice: formattedPart.price,
    totalShippingCost: formattedPart.shippingCost,
    guidSupplierInventoryWarehouse:
      formattedPart.guidSupplierInventoryWarehouse,
    totalParts: 1
  };

  return {
    formattedPart,
    formattedSupplierCart
  };
}

